import { Company } from '~/types/general';
import { CompanyResponseT } from '~/types/response/companies';
import { IJCStateFromApi, IJCState } from '~/types/models/jcState';
import { IJCStatus, IJCStatusFromApi } from '~/types/models/jcStatus';

export const adaptCompaniesDist = (company: CompanyResponseT): Company => {
  return {
    label: company.name,
    value: company.dbName,
    id: company.id,
    timeClockingLevels: company.timeClockingLevels,
    mandatoryDepartment: company.mandatoryDepartment,
    mandatorySubDepartment: company.mandatorySubDepartment,
    mandatoryWorkstation: company.mandatoryWorkstation,
  };
};

export const jobCardStateAdapter = (state: IJCStateFromApi): IJCState => {
  const { Color, Label, Code, _id } = state;

  return {
    Color,
    label: Label,
    value: Code,
    id: _id,
  };
};

export const jobCardStatusAdapter = (status: IJCStatusFromApi): IJCStatus => {
  const { Code, Closed, Label, State, ShowOnTimePortal, _id } = status;

  return {
    State,
    closed: Closed ? 'Y' : null,
    Name: Code,
    showOnTimePortal: ShowOnTimePortal,
    label: Label,
    value: Code,
    id: _id,
  };
};
